enum ActiveExperiment {
  // Keep this enum for testing purposes + having declared enum
  test = 'test',
  // After experiment is completed and code is productized please remove the enum from Active Experiments
}

export default ActiveExperiment;
